import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ICON_TYPE } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';

export enum ViewModes {
  Grid = 'grid',
  List = 'list',
}

@Component({
  selector: 'app-product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.scss'],
  standalone: false,
})
export class ProductViewComponent implements OnInit {
  iconTypes = ICON_TYPE;
  show = true;
  @Input() mode: ViewModes;
  @Output() modeChange = new EventEmitter<string>();

  isTablet: boolean = false;
  isMobile: boolean = false;

  get buttonClass() {
    const viewName: string = this.viewMode.toLowerCase();
    return `cx-product-${viewName}`;
  }

  /**
   *   Display icons inversely to allow users
   *   to see the view they will navigate to
   */
  get viewMode() {
    if (this.mode === 'list') {
      return this.iconTypes.GRID;
    } else if (this.mode === 'grid') {
      return this.iconTypes.LIST;
    }
  }

  changeMode() {
    const newMode = this.mode === ViewModes.Grid ? ViewModes.List : ViewModes.Grid;
    this.modeChange.emit(newMode);
  }

  constructor(private deviceService: DeviceDetectorService) {}

  ngOnInit() {
    this.isTablet = this.deviceService.isTablet();
    this.isMobile = this.deviceService.isMobile();

    this.showPLPBtn();
  }

  showPLPBtn(): void {
    const orientation = this.getOrientation();

    if ((this.isTablet || this.isMobile) && orientation === 'portrait') {
      this.show = false;
    } else {
      this.show = true;
    }
  }

  getOrientation(): string {
    return window.matchMedia('(orientation: landscape)').matches ? 'landscape' : 'portrait';
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.showPLPBtn();
  }
}
